export default __webpack_public_path__ + "static/media/loged-user.e95ebaef.svg";